import React, { useEffect } from "react";
import { useLenis } from "lenis/react";
import { useLocation } from "react-router-dom";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { About } from "../components/site/About";
import { Services } from "../components/site/Services";
import { Timeline } from "../components/site/Timeline";
import { Locations } from "../components/site/Locations";
import { Signup } from "../components/site/Signup";
import { Footer } from "../components/site/Footer";

export default function Home() {
  const lenis = useLenis();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => lenis?.scrollTo(hash, { offset: -20, duration: 1.2 }), 350);
      return () => clearTimeout(t);
    }
  }, [hash, lenis]);

  return (
    <div className="bg-ink" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Timeline />
        <Locations />
        <Signup />
      </main>
      <Footer />
    </div>
  );
}
